import classnames from 'classnames';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';
import { kebabCase } from 'lodash';
import entityComposition from '../common/classes/entityComposition';
import { labelSelector, newPathSelector, styleSelector } from './selectors';
import widthSelector from './selectors/widthSelector';

// this component wraps every container.
const GridCol = _ref => {
  let format = _ref.format,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? null : _ref$content,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$minControlWidth = _ref.minControlWidth,
    minControlWidth = _ref$minControlWidth === void 0 ? 0 : _ref$minControlWidth,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? {
      size: 12
    } : _ref$width,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? null : _ref$style;
  const className = useMemo(() => {
    let result = 'align-self-end';
    result = classnames('GridCol', result);
    if (format.horizontalAlignment) {
      result = classnames(result, "horz-align-".concat(format.horizontalAlignment));
    }

    // to preserve webtests.  maybe we want this to go away - especially with v2.
    if (format.type === 'row') {
      const header = format.type === 'section' ? undefined : label;
      result = classnames({
        't-grid-row': true,
        ["t-grid-row-".concat(kebabCase(header))]: !!header,
        'content-row': true
      });
    }
    return result;
  }, [format.horizontalAlignment, format.type, label]);
  if (children === undefined) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Row, {
    className: className,
    "data-testid": "grid-col"
  }, children);
};
GridCol.propTypes = {
  content: PropTypes.shape({}),
  format: PropTypes.shape({
    collapsible: PropTypes.bool,
    horizontalAlignment: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  children: PropTypes.node,
  label: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  minControlWidth: PropTypes.number,
  style: PropTypes.shape({}),
  width: PropTypes.shape({})
};
export { GridCol as UncomposedGridCol, widthSelector as testWidthSelector };
export default entityComposition(GridCol, [], {
  label: labelSelector,
  width: widthSelector,
  style: styleSelector,
  path: newPathSelector
});